<script>
import { event } from "vue-analytics";
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("menu", ["menuOpened"])
  },

  methods: {
    sendEvents(name) {
      event("cliente", "click", `SubMenu:${name}`);
    }
  }
};
</script>

<template>
  <div class="menu-mobile" :opened="menuOpened">
    <div class="container">
      <div class="content">
        <div class="row">
          <div class="box">
            <div class="icon services"></div>
            <ul>
              <li class="title">SERVIÇOS</li>
              <router-link
                @click.native="sendEvents('purchase-flow')"
                :to="{name: 'purchase-flow'}"
              >
                <li class="item">Agendar Limpeza</li>
              </router-link>
              <!-- <li class="item">Assinatura</li> -->
            </ul>
          </div>

          <div class="separator"></div>

          <div class="box">
            <div class="icon orders"></div>
            <ul>
              <li class="title">Histórico</li>
              <router-link
                @click.native="sendEvents('order-history')"
                :to="{name: 'order-history'}"
              >
                <li class="item">Limpezas</li>
              </router-link>
              <router-link
                @click.native="sendEvents('subscriptions')"
                :to="{name: 'subscriptions'}"
              >
                <li class="item">Assinaturas</li>
              </router-link>
              <!-- <li class="item">Notas Fiscais</li> -->
              <!-- <li class="item">Cupons</li> -->
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="box">
            <div class="icon users"></div>
            <ul>
              <li class="title">USUÁRIO</li>
              <router-link
                @click.native="sendEvents('personal-data')"
                :to="{name: 'personal-data'}"
              >
                <li class="item">Minha conta</li>
              </router-link>
              <router-link
                @click.native="sendEvents('help')"
                :to="{name: 'help'}">
                <li class="item">Regras e informações</li>
              </router-link>
              <!-- <li class="item">Cartões de Crédito</li> -->
              <!-- <li class="item">Carteira</li> -->
            </ul>
          </div>

          <!-- <div class="box">
                    <div class="icon preferences"></div>
                    <ul>
                        <li class="title">PREFERÊNCIAS</li>
                        <li class="item">Favoritos</li>
                        <li class="item">Bloqueados</li>
                    </ul>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.menu-mobile {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  padding-top: 70px;
  left: 0;
  color: #000 !important;
  transition: all 0.25s ease;
  box-shadow: 0px 8px 10px -11px rgba(0, 0, 0, 0.5);
  background: linear-gradient(90deg, var(--purple) 0%, var(--pink) 100%);
  z-index: 2;
  transform: translateY(-100%);
}

.separator {
  width: 1px;
  height: 100px;
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-mobile[opened="true"] {
  transform: translateY(0);
}

.menu-mobile .content {
  display: flex;
  flex-direction: column;
}

.menu-mobile .content .row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.menu-mobile .content .row .box {
  box-shadow: none;
  background: transparent;
  border: none;
  color: #fff;
  border-radius: 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.menu-mobile .content .row .box h2 {
  font-weight: 500;
}

.menu-mobile .content .row .box ul {
  width: 50%;
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
  margin-left: 30px;
}

.menu-mobile .content .row .box ul a {
  color: #fff;
}

.menu-mobile .content .row .box ul li.title {
  color: rgba(255, 255, 255, 0.33);
  margin: 0 0 10px 0;
  font-size: 10px;
}

.menu-mobile .content .row .box ul li.item {
  font-size: 16px !important;
  padding: 2px 0;
}

.icon {
  width: 70px;
  height: 70px;
  background-repeat: no-repeat !important;
  background-position: right top !important;
  background-size: contain;
}

.services {
  background: url("../../../static/menu-services.svg");
}

.orders {
  background: url("../../../static/menu-orders.svg");
}

.users {
  background: url("../../../static/menu-user.svg");
}

.preferences {
  background: url("../../../static/menu-preferences.svg");
}

@media (max-width: 992px) {
  .menu-mobile {
    display: block !important;
  }
}

@media (max-width: 768px) {
  .menu-mobile .content .row .box ul li.item {
    font-size: 14px !important;
  }
  .icon {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 480px) {
  .separator {
    display: none;
  }
  .menu-mobile .content .row {
    flex-direction: column !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/MenuMobile.vue